import {type Signal, type SignalArtifact} from "@devplaninc/codeup"
import {artifactEvidenceProvider, type EvidenceProvider} from "@/app/components/evidence/evidenceProvider"

export type EvidenceProviderCount = {
  provider: EvidenceProvider
  count: number
}

export function aggregateEvidenceProviderCounts(
  providers: Iterable<EvidenceProvider>,
): EvidenceProviderCount[] {
  const counts = new Map<EvidenceProvider, number>()

  for (const provider of providers) {
    counts.set(provider, (counts.get(provider) ?? 0) + 1)
  }

  return sortEvidenceProviderCounts(counts)
}

export function aggregateArtifactProviderCounts(
  artifacts: Iterable<SignalArtifact>,
): EvidenceProviderCount[] {
  return aggregateEvidenceProviderCounts(
    Array.from(artifacts, artifactEvidenceProvider),
  )
}

export function aggregateSignalProviderCounts(
  signals: Iterable<Signal>,
): EvidenceProviderCount[] {
  const providers: EvidenceProvider[] = []
  for (const signal of signals) {
    for (const artifact of signal.artifacts) {
      providers.push(artifactEvidenceProvider(artifact))
    }
  }
  return aggregateEvidenceProviderCounts(providers)
}

function sortEvidenceProviderCounts(
  counts: Map<EvidenceProvider, number>,
): EvidenceProviderCount[] {
  return [...counts.entries()]
    .map(([provider, count]) => ({provider, count}))
    .sort((a, b) => b.count - a.count || a.provider.localeCompare(b.provider))
}
